export const clampZoom = value => Math.min(8, Math.max(0.25, value));
export function fitImage(natural, viewport, rotate = 0) {
  if (!natural.width || !natural.height || !viewport.width || !viewport.height) return 1;
  const swapped = Math.abs(rotate % 180) === 90;
  return Math.max(0.0001, Math.min(1,
    Math.max(1, viewport.width - 32) / (swapped ? natural.height : natural.width),
    Math.max(1, viewport.height - 32) / (swapped ? natural.width : natural.height)));
}
export function boundView(view, natural, viewport) {
  const zoom = clampZoom(view.zoom), fit = fitImage(natural, viewport, view.rotate);
  const swapped = Math.abs(view.rotate % 180) === 90;
  const width = (swapped ? natural.height : natural.width) * fit * zoom;
  const height = (swapped ? natural.width : natural.height) * fit * zoom;
  const maxX = Math.max(0, (width - viewport.width) / 2 + 16);
  const maxY = Math.max(0, (height - viewport.height) / 2 + 16);
  return {...view, zoom, x: Math.max(-maxX, Math.min(maxX, view.x)), y: Math.max(-maxY, Math.min(maxY, view.y))};
}
export function zoomAt(view, zoom, point, natural, viewport) {
  const next = clampZoom(zoom), ratio = next / view.zoom;
  return boundView({...view, zoom: next, x: point.x - (point.x - view.x) * ratio,
    y: point.y - (point.y - view.y) * ratio}, natural, viewport);
}
